module.exports = __webpack_public_path__ + "img/数据服务.3d774f5f.png";